import axiosClient from '@/config/api/axios'
import { CHAT_RUNS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'

export async function fetchChatRun(runId, options = {}) {
  if (!isApiConfigured() || !runId) return null
  const { data } = await axiosClient.get(`${CHAT_RUNS}/${runId}`, {
    signal: options.signal,
  })
  return data
}
